module.exports = __webpack_public_path__ + "static/media/illustration-login.1596d9ad.png";